import React from 'react';
import Icon from './Icon';

export default function DesktopWhatsAppFab({ phone = '916353937571' }) {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent("Hi Dr. Moksha, I'd like to ask about physiotherapy.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Dr. Moksha"
      style={{
        position: 'fixed', right: 32, bottom: 32, zIndex: 30,
        width: 64, height: 64, borderRadius: 999,
        background: '#25D366', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 12px 30px rgba(37,211,102,0.4)',
        textDecoration: 'none',
      }}
    >
      <Icon name="whatsapp" size={32} stroke="#fff"/>
    </a>
  );
}
